import ko from "knockout";
import "flow/extensions/koNumeric";
import register from "flow/knockout/register";

register.registerKnockoutBinding("numericValue", {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        const underlyingObservable = valueAccessor();
        const interceptor = underlyingObservable.extend({ numeric: 0 });

        return ko.bindingHandlers.value.init(
            element,
            function () {
                return interceptor;
            },
            allBindingsAccessor,
            viewModel,
            bindingContext
        );
    },
    update: ko.bindingHandlers.value.update
});
